import { Component, Input, OnInit } from "@angular/core";
import { ActionDefinitionSparePartReference } from "../../model";

@Component({
    selector: 'spare-part-input',
    template: require('./spare-part-input.component.html')
})
export class SparePartInputComponent implements OnInit {

    @Input() sparePartReference: ActionDefinitionSparePartReference;

    @Input() readonly: boolean;

    code: string;
    quantity: number;
    format: string;
    error: string;

    private dirty: boolean;

    constructor() { }

    ngOnInit(): void {
        this.code = this.sparePartReference?.code;
        this.quantity = this.sparePartReference?.quantity || 1;
        this.format = this.sparePartReference?.format;
    }

    addQuantity(): void {
        this.quantity++;
        this.setDirty();
    }

    removeQuantity(): void {
        if (this.quantity > 1) {
            this.quantity--;
            this.setDirty();
        }
    }

    setCode(value: string): void {
        this.code = value;
        this.setDirty();
    }

    setError(value: string): void {
        this.error = value;
    }

    getValue(): ActionDefinitionSparePartReference {
        return { code: this.code, quantity: this.quantity, format: this.format };
    }

    isDirty(): boolean {
        return this.dirty;
    }

    setDirty(): void {
        this.dirty = true;
    }
}